import { InboundPackage } from "@deliverr/inbound-client";
import { Dictionary } from "lodash";
import { RootState } from "RootReducer";

export const selectBoxesByShipment = (state: RootState): Dictionary<InboundPackage[]> => state.inbound.packages;
